export { default, getStaticProps } from "app/questions/page";
